var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForceCheckout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_875_2",
    "data-name": "Component 875 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29952",
    "data-name": "Group 29952",
    transform: "translate(-1538.001 -1.733)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6864",
    "data-name": "Rectangle 6864",
    width: 22,
    height: 22,
    transform: "translate(1538.001 1.733)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30520",
    "data-name": "Path 30520",
    d: "M14149.75-18295.395h-13.256a.5.5,0,0,1-.494-.5v-17.615a.5.5,0,0,1,.494-.494h7.849a4.225,4.225,0,0,0-.346.988h-7.006v16.627h9.972l-6.726-1.885a.272.272,0,0,1-.2-.264v-12.543a.277.277,0,0,1,.206-.264l3.665-.943c0,.055,0,.1,0,.143a4.189,4.189,0,0,0,4.186,4.186,4.112,4.112,0,0,0,1.83-.42,1.584,1.584,0,0,0-.461,1.02h-3.194a1.6,1.6,0,0,0-1.594,1.6v2.125a1.6,1.6,0,0,0,1.594,1.6h3.194a1.591,1.591,0,0,0,.782,1.264v4.881a.411.411,0,0,1-.021.141.407.407,0,0,1-.1.182.253.253,0,0,1-.062.063h0l0,0a.453.453,0,0,1-.221.1A.3.3,0,0,1,14149.75-18295.395Zm-7.468-10.422a.276.276,0,0,0-.275.277v1.469a.275.275,0,0,0,.275.277.275.275,0,0,0,.274-.277v-1.469A.276.276,0,0,0,14142.282-18305.816Zm8.705,4.281a.467.467,0,0,1-.465-.465v-1.1h-4.321a.47.47,0,0,1-.467-.467v-2.26a.468.468,0,0,1,.467-.465h4.321v-1.1a.466.466,0,0,1,.465-.467.455.455,0,0,1,.307.115l3.079,2.7a.464.464,0,0,1,.159.35.481.481,0,0,1-.159.352l-3.079,2.693A.457.457,0,0,1,14150.987-18301.535Z",
    transform: "translate(-12596 18318.129)",
    fill: "#637381"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30519",
    "data-name": "Path 30519",
    d: "M22698.264,12625.508a3.255,3.255,0,1,1,3.254-3.255A3.26,3.26,0,0,1,22698.264,12625.508Zm0-2.777h0l.592.593a.349.349,0,0,0,.24.1.336.336,0,0,0,.236-.1.342.342,0,0,0,0-.477l-.592-.591.592-.595a.337.337,0,0,0-.477-.477l-.592.594-.6-.594a.329.329,0,0,0-.236-.1.325.325,0,0,0-.238.1.336.336,0,0,0,0,.474l.592.595-.59.588a.342.342,0,0,0,0,.479.324.324,0,0,0,.234.1.329.329,0,0,0,.24-.1l.594-.59Z",
    transform: "translate(-21146.164 -12616.267)",
    fill: "#637381"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForceCheckout);
export default __webpack_public_path__ + "static/media/Force_Checkout.cff78d07918a583b007207654db87d35.svg";
export { ForwardRef as ReactComponent };